/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getShopSettings = /* GraphQL */ `
  query GetShopSettings($id: ID!) {
    getShopSettings(id: $id) {
      id
      locationId
      currentRO
      settingsJson
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listShopSettings = /* GraphQL */ `
  query ListShopSettings(
    $filter: ModelShopSettingsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listShopSettings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        locationId
        currentRO
        settingsJson
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBay = /* GraphQL */ `
  query GetBay($id: ID!) {
    getBay(id: $id) {
      id
      locationId
      shopId
      bayNumber
      label
      type
      zone
      x
      y
      width
      height
      active
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBays = /* GraphQL */ `
  query ListBays(
    $filter: ModelBayFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBays(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        locationId
        shopId
        bayNumber
        label
        type
        zone
        x
        y
        width
        height
        active
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTruck = /* GraphQL */ `
  query GetTruck($id: ID!) {
    getTruck(id: $id) {
      id
      locationId
      repairOrder
      companyName
      truckNumber
      reason
      status
      position
      techNumbers
      warranty
      contactPerson
      phone
      email
      partsHandling
      customerCheckInId
      year
      make
      model
      vin
      mileage
      hours
      faults
      startTime
      lastStatusChange
      lastNote
      timeInWip
      wipStartTime
      isPaused
      notes
      statusHistory {
        status
        timeEntered
        __typename
      }
      serviceSummary
      repairCategories {
        category
        subcategory
        estimatedTime
        completionTime
        __typename
      }
      repairCategory
      repairSubcategory
      estimatedTime
      completionTime
      expired
      warning
      critical
      completionType
      bayId
      location
      priorityScore
      slaRisk
      downtimeSeverity
      isHardDown
      fleetId
      fleetPriority
      flaggedHours
      partsStatus
      partsEta
      estimatedCompletion
      promisedTime
      blockers {
        type
        description
        since
        resolvedAt
        __typename
      }
      activities {
        id
        type
        text
        author
        timestamp
        photos
        customerFacing
        category
        stage
        __typename
      }
      currentBlocker {
        type
        description
        setBy
        setAt
        resolvedAt
        resolvedBy
        owner
        __typename
      }
      blockerHistory {
        type
        description
        setBy
        setAt
        resolvedAt
        resolvedBy
        owner
        __typename
      }
      laborType
      customerType
      shopId
      parts {
        id
        description
        partNumber
        vendor
        quantity
        cost
        price
        status
        orderedAt
        receivedAt
        eta
        notes
        addedBy
        addedAt
        __typename
      }
      estimates {
        id
        truckId
        roNumber
        status
        shopSupplies
        shopSuppliesPct
        taxRate
        subtotal
        tax
        total
        notes
        customerNotes
        token
        sentAt
        approvedAt
        approvalMethod
        approvedBy
        approvalNotes
        declinedAt
        declineReason
        invoicedAt
        lockedAt
        paymentTermsDays
        createdBy
        createdAt
        updatedAt
        version
        __typename
      }
      customerId
      unitId
      poNumber
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTrucks = /* GraphQL */ `
  query ListTrucks(
    $filter: ModelTruckFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTrucks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        locationId
        repairOrder
        companyName
        truckNumber
        reason
        status
        position
        techNumbers
        warranty
        contactPerson
        phone
        email
        partsHandling
        customerCheckInId
        year
        make
        model
        vin
        mileage
        hours
        faults
        startTime
        lastStatusChange
        lastNote
        timeInWip
        wipStartTime
        isPaused
        notes
        serviceSummary
        repairCategory
        repairSubcategory
        estimatedTime
        completionTime
        expired
        warning
        critical
        completionType
        bayId
        location
        priorityScore
        slaRisk
        downtimeSeverity
        isHardDown
        fleetId
        fleetPriority
        flaggedHours
        partsStatus
        partsEta
        estimatedCompletion
        promisedTime
        laborType
        customerType
        shopId
        customerId
        unitId
        poNumber
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCustomer = /* GraphQL */ `
  query GetCustomer($id: ID!) {
    getCustomer(id: $id) {
      id
      shopId
      name
      contactPerson
      phone
      email
      customerType
      fleetId
      partsHandling
      paymentTermsDays
      warranty
      notes
      poRequired
      creditHold
      creditHoldNote
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCustomers = /* GraphQL */ `
  query ListCustomers(
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        shopId
        name
        contactPerson
        phone
        email
        customerType
        fleetId
        partsHandling
        paymentTermsDays
        warranty
        notes
        poRequired
        creditHold
        creditHoldNote
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUnit = /* GraphQL */ `
  query GetUnit($id: ID!) {
    getUnit(id: $id) {
      id
      shopId
      customerId
      vin
      unitNumber
      year
      make
      model
      mileage
      hours
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUnits = /* GraphQL */ `
  query ListUnits(
    $filter: ModelUnitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUnits(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        shopId
        customerId
        vin
        unitNumber
        year
        make
        model
        mileage
        hours
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getColumnTimeout = /* GraphQL */ `
  query GetColumnTimeout($id: ID!) {
    getColumnTimeout(id: $id) {
      id
      columnId
      limit
      warning
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listColumnTimeouts = /* GraphQL */ `
  query ListColumnTimeouts(
    $filter: ModelColumnTimeoutFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listColumnTimeouts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        columnId
        limit
        warning
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTechnician = /* GraphQL */ `
  query GetTechnician($id: ID!) {
    getTechnician(id: $id) {
      id
      locationId
      name
      number
      specialties
      active
      currentLoad
      completionRate
      order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTechnicians = /* GraphQL */ `
  query ListTechnicians(
    $filter: ModelTechnicianFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTechnicians(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        locationId
        name
        number
        specialties
        active
        currentLoad
        completionRate
        order
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCustomerCheckIn = /* GraphQL */ `
  query GetCustomerCheckIn($id: ID!) {
    getCustomerCheckIn(id: $id) {
      id
      locationId
      companyName
      contactPerson
      phone
      email
      serviceReason
      partsHandling
      signatureImage
      agreementConfirmed
      status
      timestamp
      createdAt
      updatedAt
      vehicleYear
      vehicleMake
      vehicleModel
      vehicleVin
      vehicleMileage
      vehicleEngineHours
      vehicleFaults
      __typename
    }
  }
`;
export const listCustomerCheckIns = /* GraphQL */ `
  query ListCustomerCheckIns(
    $filter: ModelCustomerCheckInFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomerCheckIns(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        locationId
        companyName
        contactPerson
        phone
        email
        serviceReason
        partsHandling
        signatureImage
        agreementConfirmed
        status
        timestamp
        createdAt
        updatedAt
        vehicleYear
        vehicleMake
        vehicleModel
        vehicleVin
        vehicleMileage
        vehicleEngineHours
        vehicleFaults
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRepairEvent = /* GraphQL */ `
  query GetRepairEvent($id: ID!) {
    getRepairEvent(id: $id) {
      id
      locationId
      shopId
      roNumber
      sourceTruckId
      vin
      unitNumber
      engineFamily
      make
      model
      year
      classificationId
      quotedLaborHours
      actualLaborHours
      completedAt
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRepairEvents = /* GraphQL */ `
  query ListRepairEvents(
    $filter: ModelRepairEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRepairEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        locationId
        shopId
        roNumber
        sourceTruckId
        vin
        unitNumber
        engineFamily
        make
        model
        year
        classificationId
        quotedLaborHours
        actualLaborHours
        completedAt
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLaborAggregate = /* GraphQL */ `
  query GetLaborAggregate($id: ID!) {
    getLaborAggregate(id: $id) {
      id
      scope
      scopeId
      classificationId
      count
      sumHours
      updatedAt
      createdAt
      __typename
    }
  }
`;
export const listLaborAggregates = /* GraphQL */ `
  query ListLaborAggregates(
    $filter: ModelLaborAggregateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLaborAggregates(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        scope
        scopeId
        classificationId
        count
        sumHours
        updatedAt
        createdAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOperationEvent = /* GraphQL */ `
  query GetOperationEvent($id: ID!) {
    getOperationEvent(id: $id) {
      id
      eventType
      timestamp
      locationId
      assetId
      workOrderId
      technicianId
      userId
      previousStatus
      newStatus
      note
      relatedPhotoIds
      metadata
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOperationEvents = /* GraphQL */ `
  query ListOperationEvents(
    $filter: ModelOperationEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOperationEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        eventType
        timestamp
        locationId
        assetId
        workOrderId
        technicianId
        userId
        previousStatus
        newStatus
        note
        relatedPhotoIds
        metadata
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRoadServiceCall = /* GraphQL */ `
  query GetRoadServiceCall($id: ID!) {
    getRoadServiceCall(id: $id) {
      id
      customerId
      assetId
      locationId
      customerName
      companyName
      contactName
      callbackPhone
      unitNumber
      vin
      complaint
      roadServiceAddress
      destinationLatitude
      destinationLongitude
      vehicleYear
      vehicleMake
      vehicleModel
      vehicleColor
      priority
      assignedTechnicianId
      assignedServiceTruckId
      status
      workOrderId
      dispatchedAt
      travelStartedAt
      arrivedAt
      workStartedAt
      completedAt
      cancelledAt
      acceptedAt
      acceptedByTechnicianId
      holdStartedAt
      currentHoldReason
      currentHoldNote
      holdResumeStatus
      returnedAt
      odometerOut
      odometerReturn
      billedMiles
      billedHours
      billingNote
      customerSignatureUrl
      locationRequestToken
      locationRequestPhone
      locationRequestedAt
      locationReceivedAt
      locationRequestStatus
      locationSource
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRoadServiceCalls = /* GraphQL */ `
  query ListRoadServiceCalls(
    $filter: ModelRoadServiceCallFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRoadServiceCalls(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerId
        assetId
        locationId
        customerName
        companyName
        contactName
        callbackPhone
        unitNumber
        vin
        complaint
        roadServiceAddress
        destinationLatitude
        destinationLongitude
        vehicleYear
        vehicleMake
        vehicleModel
        vehicleColor
        priority
        assignedTechnicianId
        assignedServiceTruckId
        status
        workOrderId
        dispatchedAt
        travelStartedAt
        arrivedAt
        workStartedAt
        completedAt
        cancelledAt
        acceptedAt
        acceptedByTechnicianId
        holdStartedAt
        currentHoldReason
        currentHoldNote
        holdResumeStatus
        returnedAt
        odometerOut
        odometerReturn
        billedMiles
        billedHours
        billingNote
        customerSignatureUrl
        locationRequestToken
        locationRequestPhone
        locationRequestedAt
        locationReceivedAt
        locationRequestStatus
        locationSource
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRoadServiceStatusEvent = /* GraphQL */ `
  query GetRoadServiceStatusEvent($id: ID!) {
    getRoadServiceStatusEvent(id: $id) {
      id
      roadServiceCallId
      locationId
      status
      fromStatus
      at
      technicianId
      techNumber
      techName
      holdReason
      holdNote
      resumeStatus
      source
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRoadServiceStatusEvents = /* GraphQL */ `
  query ListRoadServiceStatusEvents(
    $filter: ModelRoadServiceStatusEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRoadServiceStatusEvents(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        roadServiceCallId
        locationId
        status
        fromStatus
        at
        technicianId
        techNumber
        techName
        holdReason
        holdNote
        resumeStatus
        source
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTimeEntry = /* GraphQL */ `
  query GetTimeEntry($id: ID!) {
    getTimeEntry(id: $id) {
      id
      locationId
      workOrderId
      roadServiceCallId
      technicianId
      techNumber
      techName
      kind
      startedAt
      endedAt
      seconds
      billedAt
      billedEstimateId
      note
      source
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTimeEntries = /* GraphQL */ `
  query ListTimeEntries(
    $filter: ModelTimeEntryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTimeEntries(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        locationId
        workOrderId
        roadServiceCallId
        technicianId
        techNumber
        techName
        kind
        startedAt
        endedAt
        seconds
        billedAt
        billedEstimateId
        note
        source
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTechnicianLocation = /* GraphQL */ `
  query GetTechnicianLocation($id: ID!) {
    getTechnicianLocation(id: $id) {
      id
      technicianId
      userId
      locationId
      latitude
      longitude
      accuracy
      heading
      speed
      timestamp
      source
      activeRoadServiceCallId
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTechnicianLocations = /* GraphQL */ `
  query ListTechnicianLocations(
    $filter: ModelTechnicianLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTechnicianLocations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        technicianId
        userId
        locationId
        latitude
        longitude
        accuracy
        heading
        speed
        timestamp
        source
        activeRoadServiceCallId
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const trucksByCustomer = /* GraphQL */ `
  query TrucksByCustomer(
    $customerId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTruckFilterInput
    $limit: Int
    $nextToken: String
  ) {
    trucksByCustomer(
      customerId: $customerId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        locationId
        repairOrder
        companyName
        truckNumber
        reason
        status
        position
        techNumbers
        warranty
        contactPerson
        phone
        email
        partsHandling
        customerCheckInId
        year
        make
        model
        vin
        mileage
        hours
        faults
        startTime
        lastStatusChange
        lastNote
        timeInWip
        wipStartTime
        isPaused
        notes
        serviceSummary
        repairCategory
        repairSubcategory
        estimatedTime
        completionTime
        expired
        warning
        critical
        completionType
        bayId
        location
        priorityScore
        slaRisk
        downtimeSeverity
        isHardDown
        fleetId
        fleetPriority
        flaggedHours
        partsStatus
        partsEta
        estimatedCompletion
        promisedTime
        laborType
        customerType
        shopId
        customerId
        unitId
        poNumber
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const trucksByUnit = /* GraphQL */ `
  query TrucksByUnit(
    $unitId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTruckFilterInput
    $limit: Int
    $nextToken: String
  ) {
    trucksByUnit(
      unitId: $unitId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        locationId
        repairOrder
        companyName
        truckNumber
        reason
        status
        position
        techNumbers
        warranty
        contactPerson
        phone
        email
        partsHandling
        customerCheckInId
        year
        make
        model
        vin
        mileage
        hours
        faults
        startTime
        lastStatusChange
        lastNote
        timeInWip
        wipStartTime
        isPaused
        notes
        serviceSummary
        repairCategory
        repairSubcategory
        estimatedTime
        completionTime
        expired
        warning
        critical
        completionType
        bayId
        location
        priorityScore
        slaRisk
        downtimeSeverity
        isHardDown
        fleetId
        fleetPriority
        flaggedHours
        partsStatus
        partsEta
        estimatedCompletion
        promisedTime
        laborType
        customerType
        shopId
        customerId
        unitId
        poNumber
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const customersByShop = /* GraphQL */ `
  query CustomersByShop(
    $shopId: String!
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customersByShop(
      shopId: $shopId
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        shopId
        name
        contactPerson
        phone
        email
        customerType
        fleetId
        partsHandling
        paymentTermsDays
        warranty
        notes
        poRequired
        creditHold
        creditHoldNote
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const unitsByCustomer = /* GraphQL */ `
  query UnitsByCustomer(
    $customerId: ID!
    $unitNumber: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUnitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    unitsByCustomer(
      customerId: $customerId
      unitNumber: $unitNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        shopId
        customerId
        vin
        unitNumber
        year
        make
        model
        mileage
        hours
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const unitsByVin = /* GraphQL */ `
  query UnitsByVin(
    $vin: String!
    $sortDirection: ModelSortDirection
    $filter: ModelUnitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    unitsByVin(
      vin: $vin
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        shopId
        customerId
        vin
        unitNumber
        year
        make
        model
        mileage
        hours
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const operationEventsByAsset = /* GraphQL */ `
  query OperationEventsByAsset(
    $assetId: ID!
    $timestamp: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOperationEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    operationEventsByAsset(
      assetId: $assetId
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        eventType
        timestamp
        locationId
        assetId
        workOrderId
        technicianId
        userId
        previousStatus
        newStatus
        note
        relatedPhotoIds
        metadata
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const operationEventsByWorkOrder = /* GraphQL */ `
  query OperationEventsByWorkOrder(
    $workOrderId: ID!
    $timestamp: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOperationEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    operationEventsByWorkOrder(
      workOrderId: $workOrderId
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        eventType
        timestamp
        locationId
        assetId
        workOrderId
        technicianId
        userId
        previousStatus
        newStatus
        note
        relatedPhotoIds
        metadata
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const operationEventsByTechnician = /* GraphQL */ `
  query OperationEventsByTechnician(
    $technicianId: ID!
    $timestamp: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOperationEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    operationEventsByTechnician(
      technicianId: $technicianId
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        eventType
        timestamp
        locationId
        assetId
        workOrderId
        technicianId
        userId
        previousStatus
        newStatus
        note
        relatedPhotoIds
        metadata
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const roadServiceStatusEventsByCall = /* GraphQL */ `
  query RoadServiceStatusEventsByCall(
    $roadServiceCallId: ID!
    $at: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRoadServiceStatusEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    roadServiceStatusEventsByCall(
      roadServiceCallId: $roadServiceCallId
      at: $at
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        roadServiceCallId
        locationId
        status
        fromStatus
        at
        technicianId
        techNumber
        techName
        holdReason
        holdNote
        resumeStatus
        source
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const timeEntriesByWorkOrder = /* GraphQL */ `
  query TimeEntriesByWorkOrder(
    $workOrderId: ID!
    $startedAt: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTimeEntryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    timeEntriesByWorkOrder(
      workOrderId: $workOrderId
      startedAt: $startedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        locationId
        workOrderId
        roadServiceCallId
        technicianId
        techNumber
        techName
        kind
        startedAt
        endedAt
        seconds
        billedAt
        billedEstimateId
        note
        source
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const timeEntriesByRoadServiceCall = /* GraphQL */ `
  query TimeEntriesByRoadServiceCall(
    $roadServiceCallId: ID!
    $startedAt: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTimeEntryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    timeEntriesByRoadServiceCall(
      roadServiceCallId: $roadServiceCallId
      startedAt: $startedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        locationId
        workOrderId
        roadServiceCallId
        technicianId
        techNumber
        techName
        kind
        startedAt
        endedAt
        seconds
        billedAt
        billedEstimateId
        note
        source
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const timeEntriesByTechnician = /* GraphQL */ `
  query TimeEntriesByTechnician(
    $technicianId: ID!
    $startedAt: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTimeEntryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    timeEntriesByTechnician(
      technicianId: $technicianId
      startedAt: $startedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        locationId
        workOrderId
        roadServiceCallId
        technicianId
        techNumber
        techName
        kind
        startedAt
        endedAt
        seconds
        billedAt
        billedEstimateId
        note
        source
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const techLocByTechnician = /* GraphQL */ `
  query TechLocByTechnician(
    $technicianId: ID!
    $timestamp: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTechnicianLocationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    techLocByTechnician(
      technicianId: $technicianId
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        technicianId
        userId
        locationId
        latitude
        longitude
        accuracy
        heading
        speed
        timestamp
        source
        activeRoadServiceCallId
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
